import * as constants from '../constants/ActionTypes';
import { chatType, MODAL_TYPE } from '../constants/UtilVariables';

const initialState = {
  isModalOpen: false,
  channel: '',
  fromChannel: '',
  topic: null,
  type: MODAL_TYPE.login,
  message: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.LOAD_MODAL_CONTAINER :
      return Object.assign({}, state, { isModalOpen: true, channel: action.payload, topic: null });
    case constants.LOAD_MESSAGE_MODAL:
      return Object.assign({}, initialState, {
        isModalOpen: true,
        type: MODAL_TYPE.message,
        message: action.payload && action.payload.message,
        channel: action.payload && action.payload.channel,
        topic: action.payload && action.payload.topic,
      });
    case constants.CLOSE_MODAL_CONTAINER :
      return initialState;
    case constants.LOGIN_CALLUS :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: 'callUs', topic: action.payload });
    case constants.LOGIN_CHAT_BOT :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: chatType.chatBot, topic: action.payload });
    case constants.LOGIN_LIVE_CHAT :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: chatType.liveChat, topic: action.payload });
    case constants.LOGIN_EMAIL :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: 'emailUs', topic: null });
    case constants.LOGIN_EMAIL_NO_INTENT :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: 'email', topic: null });
    case constants.REQUEST_CALLUS :
    case constants.REQUEST_BY_EMAIL :
      return Object.assign({}, state, { isModalOpen: false, fromChannel: '', topic: null });
    case constants.SELECT_TOPIC_L1:
    case constants.SELECT_TOPIC_L2:
    case constants.SELECT_TOPIC_L3:
    case constants.SELECT_TOPIC_RESET:
    case constants.LOAD_CHAT_INELIGIBLE_MODAL_CONTAINER:
    case constants.CLOSE_CHAT_INELIGIBLE_MODAL_CONTAINER:
      return initialState;
    default:
      return state;
  }
}
